import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/facebook-marketplace-badges';

export default function Example() {
  return (
    <>
      <Head>
        <title>Seller Goals: Here Are The 4 Facebook Marketplace Badges You Should Aim To Have</title>
        <meta
          name='description'
          content="As a seller, your transaction history can make or break your image and performance in the marketplace. So, your goal is to have a great commerce profile, and here's how badges can help you achieve that."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/facebook-marketplace-badges' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/facebook-marketplace-badges' />
        <meta
          property='og:title'
          content='Seller Goals: Here Are The 4 Facebook Marketplace Badges You Should Aim To Have'
        />
        <meta
          property='og:description'
          content="As a seller, your transaction history can make or break your image and performance in the marketplace. So, your goal is to have a great commerce profile, and here's how badges can help you achieve that."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='Facebook Marketplace' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
